import { useState, useEffect } from "react";
import { GET_PAGE_CONTENT } from "../api/constants";

export const usePageContent = (code) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!code) {
      setContent(null);
      setLoading(false);
      return;
    }

    const fetchPageContent = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${GET_PAGE_CONTENT}/${code}`);
        const data = await response.json();

        if (data.status) {
          setContent(data.data || null);
        } else {
          setContent(null);
          setError(data.message || "Page content not found.");
        }
      } catch (err) {
        console.error("Error fetching page content:", err);
        setError("Failed to fetch page content.");
      } finally {
        setLoading(false);
      }
    };

    fetchPageContent();
  }, [code]);

  return { content, loading, error };
};
